/** Libellés alignés sur la navigation latérale. */
export const breadcrumbLabels = {
  dashboard: 'Tableau de bord',
  specialistsParent: 'Liste des spécialistes',
  psychologistsList: 'Liste des psychologues',
  socialWorkersList: 'Liste des assistantes sociales',
  addSpecialist: 'Ajouter un spécialiste',
  addSocialWorker: 'Ajouter une assistante sociale',
  editSpecialist: 'Modifier un spécialiste',
  editSocialWorker: 'Modifier une assistante sociale',
  showSpecialist: 'Fiche spécialiste',
  showSocialWorker: 'Fiche assistante sociale',
  convertSpecialist: 'Convertir un spécialiste',
  interventions: "Demande d'intervention",
  newIntervention: 'Nouvelle demande',
  manageIntervention: 'Gérer une intervention',
  specialistsMap: 'Carte des spécialistes',
  restore: 'Réactiver des spécialistes',
  prospects: 'Liste des prospects',
  showProspect: 'Fiche prospect',
  editProspect: 'Modifier un prospect',
  convertProspect: 'Convertir un prospect',
  showOfficeSpecialist: 'Fiche psychologue en cabinet',
  editOfficeSpecialist: 'Modifier un psychologue en cabinet',
  adminOptions: 'Gérer les options',
  companies: 'Les entreprises',
  addCompany: 'Ajouter une entreprise',
  editCompany: 'Modifier une entreprise',
  specialities: 'Les Spécialités cliniques',
  addSpeciality: 'Ajouter une spécialité',
  editSpeciality: 'Modifier une spécialité',
  experiences: 'Les expériences',
  addExperience: 'Ajouter une expérience',
  editExperience: 'Modifier une expérience',
  expertises: 'Les expertises',
  addExpertise: 'Ajouter une expertise',
  editExpertise: 'Modifier une expertise',
  languages: 'Les langues',
  addLanguage: 'Ajouter une langue',
  editLanguage: 'Modifier une langue',
  administratifStatus: 'Les statuts',
  addAdministratifStatus: 'Ajouter un statut',
  editAdministratifStatus: 'Modifier un statut',
  certifications: 'Les certifications',
  addCertification: 'Ajouter une certification',
  editCertification: 'Modifier une certification',
  users: 'Liste des utilisateurs',
  editUser: 'Modifier un utilisateur',
  profile: 'Mon profil',
  journalisation: 'Journalisation des connexions',
} as const;
